import React, { PropTypes, useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";

import styles from "./footer.module.scss";

export default function Footer() {

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth',
    });
  };
  
  return (
    <footer className={styles.footer}>
      <main>
        <section>
          <div className={styles.rowSection}>
            <div className={styles.colSection}>
              <div>
                <h5 className={styles.linksTitle}>PRODUCTS</h5>
                <ul>
                  <a href="https://www.paperflite.com/product">
                    <li>PAPERFLITE</li>
                  </a>
                  <a href="https://www.paperflite.com/cleverstory">
                    <li>CLEVERSTORY</li>
                  </a>
                  <a href="https://www.paperflite.com/heysales">
                    <li>HEYSALES</li>
                  </a>
                </ul>
                <h5 className={styles.linksTitle}>solutions</h5>
                <ul>
                  <a href="https://www.paperflite.com/paperflite_for_marketing">
                    <li>PAPERFLITE FOR MARKETING</li>
                  </a>
                  <a href="https://www.paperflite.com/paperflite_for_inside_sales">
                    <li>PAPERFLITE FOR INSIDE SALES</li>
                  </a>
                  <a href="https://www.paperflite.com/paperflite_for_field_sales">
                    <li>PAPERFLITE FOR FIELD SALES</li>
                  </a>
                  <li className={styles.socialLinks}>
                    <a
                      href="https://in.linkedin.com/company/paperflite"
                      target="_blank"
                      className={styles.socialIcons}
                    >
                      <img src="https://paperflite-website-files.s3.amazonaws.com/images/Social-Media-Icons/linkedin.svg" />
                    </a>
                    <a
                      href="https://www.facebook.com/paperflite"
                      target="_blank"
                      className={styles.socialIcons}
                    >
                      <img src="https://paperflite-website-files.s3.amazonaws.com/images/Social-Media-Icons/fb.svg" />
                    </a>
                    <a
                      href="https://www.twitter.com/paperflite"
                      target="_blank"
                      className={styles.socialIcons}
                    >
                      <img src="https://paperflite-website-files.s3.amazonaws.com/images/Social-Media-Icons/twitter.svg" />
                    </a>
                    <a
                      href="https://www.youtube.com/channel/UCG77iAbJe6wNLGLqWhy_GnA"
                      target="_blank"
                      className={styles.socialIcons}
                    >
                      <img src="https://paperflite-website-files.s3.amazonaws.com/images/Social-Media-Icons/youtube.svg" />
                    </a>
                </li>
                </ul>
              </div>
            </div>
            <div className={styles.colSection}>
              <div>
                <h5 className={styles.linksTitle}>FEATURES</h5>
                <ul>
                  <a href="https://www.paperflite.com/product/content-discovery">
                    <li>CONTENT DISCOVERY</li>
                  </a>
                  <a href="https://www.paperflite.com/product/content-experience">
                    <li>CONTENT EXPERIENCE</li>
                  </a>
                  <a href="https://www.paperflite.com/product/content-distribution">
                    <li>CONTENT DISTRIBUTION</li>
                  </a>
                  <a href="https://www.paperflite.com/product/content-analytics">
                    <li>CONTENT ANALYTICS</li>
                  </a>
                  <a href="https://www.paperflite.com/product/content-intelligence">
                    <li>CONTENT INTELLIGENCE</li>
                  </a>
                  <a
                    href="https://www.paperflite.com/product/engage/"
                    target="_blank"
                  >
                    <li>Engage - Conversational Engine</li>
                  </a>
                  <a
                    href="https://experiences.cleverstory.io/introducing-seek"
                    target="_blank"
                  >
                    <li>Seek - Powered by Generative AI</li>
                  </a>
                  <a
                    href="https://experiences.cleverstory.io/Digital-Sales-Room"
                    target="_blank"
                  >
                    <li>Digital sales room</li>
                  </a>
                </ul>
              </div>
            </div>
            <div className={styles.colSection}>
              <div>
                <h5 className={styles.linksTitle}>ALTERNATIVES</h5>
                <ul>
                  <a href="https://www.paperflite.com/alternatives/docsend-alternative">
                    <li>DOCSEND ALTERNATIVE</li>
                  </a>
                  <a href="https://www.paperflite.com/alternatives/pointdrive-alternative">
                    <li>POINTDRIVE ALTERNATIVE</li>
                  </a>
                  <a href="https://www.paperflite.com/alternatives/dropbox-showcase-alternative">
                    <li>DROPBOX SHOWCASE ALTERNATIVE</li>
                  </a>
                  <a href="https://product.paperflite.com/folleon-alternative">
                    <li>FOLEON ALTERNATIVE</li>
                  </a>
                  <a href="https://product.paperflite.com/turtle-alternative">
                    <li>TURTL ALTERNATIVE</li>
                  </a>
                  <a href="https://product.paperflite.com/ceros-alternative">
                    <li>CEROS ALTERNATIVE</li>
                  </a>
                  <a href="https://www.paperflite.com/alternatives/showpad-alternative">
                    <li>SHOWPAD ALTERNATIVE</li>
                  </a>
                  <a href="https://product.paperflite.com/highspot-alternative">
                    <li>HIGHSPOT ALTERNATIVE</li>
                  </a>
                  <a href="https://product.paperflite.com/seismic-alternative">
                    <li>SEISMIC ALTERNATIVE</li>
                  </a>
                  <a href="https://product.paperflite.com/pathfactoryalternative/why-should-you-choose-paperflite">
                    <li>PATHFACTORY ALTERNATIVE</li>
                  </a>
                  <a href="https://product.paperflite.com/mediafly-alternative">
                    <li>MEDIAFLY ALTERNATIVE</li>
                  </a>
                </ul>
              </div>
            </div>
            <div className={styles.colSection}>
              <div>
                <h5 className={styles.linksTitle}>INTEGRATIONS</h5>
                <ul>
                  <a href="https://www.paperflite.com/integrations/eloqua-integration">
                    <li>ELOQUA</li>
                  </a>
                  <a href="https://www.paperflite.com/integrations/freshsales-integration">
                    <li>FRESHSALES</li>
                  </a>
                  <a href="https://www.paperflite.com/integrations/hubspot-integration">
                    <li>HUBSPOT</li>
                  </a>
                  <a href="https://www.paperflite.com/integrations/klenty-integration">
                    <li>KLENTY</li>
                  </a>
                  <a href="https://www.paperflite.com/integrations/pipedrive-integration">
                    <li>PIPEDRIVE</li>
                  </a>
                  <a href="https://www.paperflite.com/integrations/msDynamics-integration">
                    <li>MS DYNAMICS</li>
                  </a>
                  <a href="https://www.paperflite.com/integrations/salesloft-integration">
                    <li>SALESLOFT</li>
                  </a>
                  <a href="https://experiences.cleverstory.io/paperflite-salesforce">
                    <li>SALESFORCE</li>
                  </a>
                </ul>
              </div>
            </div>
            <div className={styles.colSection}>
              <div>
                <h5 className={styles.linksTitle}>LINKS</h5>
                <ul>
                  <a href="https://www.paperflite.com/pricing">
                    <li>PRICING</li>
                  </a>
                  <a href="https://app.paperflite.com/hub/streams">
                    <li>LOGIN</li>
                  </a>
                  <a href="https://app.paperflite.com/privacy">
                    <li>PRIVACY POLICY</li>
                  </a>
                  <a href="https://app.paperflite.com/terms">
                    <li>TERMS & CONDITIONS</li>
                  </a>
                  <a href="https://www.paperflite.com/gdpr-compliance">
                    <li>SECURITY AND COMPLIANCE</li>
                  </a>
                  <a href="https://support.paperflite.com/en/">
                    <li>SUPPORT CENTER</li>
                  </a>
                </ul>
                <h5 className={styles.linksTitle}>CUSTOMER STORIES</h5>
                <ul>
                  <a href="https://showcase.cleverstory.io/paperflite-for-tis">
                    <li>TIS</li>
                  </a>
                  <a href="https://experiences.cleverstory.io/venus-case-study">
                    <li>VENUS</li>
                  </a>
                  <a href="https://showcase.cleverstory.io/BisonJacks">
                    <li>BISON JACKS</li>
                  </a>
                  <a href="https://www.paperflite.com/blogs/how-aspire-systems-solved-its-deep-rooted-content-issue-using-paperflite">
                    <li>ASPIRE SYSTEMS</li>
                  </a>
                  <a href="https://experiences.cleverstory.io/perfection-learning-case-study">
                    <li>PERFECTION LEARNING</li>
                  </a>
                  <a href="https://experiences.cleverstory.io/kendo-case-study">
                    <li>KENDO</li>
                  </a>
                  <a href="https://experiences.cleverstory.io/armada-case-study">
                    <li>ARMADA</li>
                  </a>
                  <a href="https://experiences.cleverstory.io/acrolinx-case-study">
                    <li>ACROLINX</li>
                  </a>
                  <a href="https://experiences.cleverstory.io/e2open-selling-in-a-tempest">
                    <li>E2OPEN</li>
                  </a>
                  <a href="https://showcase.cleverstory.io/mint-case-study">
                    <li>MINT</li>
                  </a>
                  <a href="https://experiences.cleverstory.io/servicenow">
                    <li>SERVICE NOW</li>
                  </a>
                </ul>
              </div>
            </div>
          </div>
          <div className={styles.rowSectionTwo}>
            <div className="">
              <p>PAPERFLITE IS NOW AVAILABLE ON</p>
            </div>
            <div className={styles.appStoreImg}>
              <a
                href="https://appsource.microsoft.com/en-us/product/dynamics-365/paperfliteinc1652251834907.15072022?exp=ubp8&tab=Overview"
                target="_blank"
              >
                <img
                  src="https://www.paperflite.com/themes/custom/paperflite/images/footer-icons/microsoft.png"
                />
              </a>
              <a
                href="https://apps.apple.com/in/app/paperflite/id1310538840"
                target="_blank"
              >
                <img
                  src="https://www.paperflite.com/themes/custom/paperflite/images/footer-icons/appstore.svg"
                  alt="appstore"
                />
              </a>
              <a
                href="https://play.google.com/store/apps/details?id=com.paperflite.droid"
                target="_blank"
              >
                <img
                  src="https://www.paperflite.com/themes/custom/paperflite/images/footer-icons/playstore.svg"
                  alt="playstore"
                />
              </a>
              <a
                href="https://chrome.google.com/webstore/detail/paperflite-extension-for/gghdahjgeomeiohiecmfmdomeighihih?hl=en"
                target="_blank"
              >
                <img
                  src="https://www.paperflite.com/themes/custom/paperflite/images/footer-icons/chrome.svg"
                  alt="chrome"
                />
              </a>
              <a
                href="https://www.paperflite.com/security-compliance"
                target="_blank"
              >
                <img
                  height="auto"
                  src="https://www.paperflite.com/themes/custom/paperflite/images/soc-cpa.png"
                  className={styles.soc}
                />
              </a>
              <a
                href="https://www.paperflite.com/security-compliance"
                target="_blank"
              >
                <img
                  height="auto"
                  className={styles.soc}
                  src="https://www.paperflite.com/themes/custom/paperflite/images/gdpr.png"
                />
              </a>
            </div>
          </div>
        </section>
      </main>
      <section className={styles.copyRight}>
        <div className={styles.rowSectionThree}>
          <div className="">
            <p>© 2026 PAPERFLITE</p>
          </div>
          <div className="">
            <div className={styles.scrollToTop} onClick={scrollToTop}>
              <p>TO THE TOP ^</p>
            </div>
          </div>
        </div>
      </section>
    </footer>
  );
}
